import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmDialogModule, GrowlModule, TooltipModule } from 'primeng/primeng';
import { HelperModule } from '../../../../common/helper/helper.module';
import { UploadEvsService } from '../../../../common/services/UploadEvs.service';
import { CardModule } from '../../../../layout/card';
import { PaginationModule } from '../../../../layout/pagination';
import { ToastrModule } from 'ngx-toastr';
// import { AgmCoreModule } from '@agm/core';
import { ContactsComponent } from './contacts.component';
import { ContactService } from '../../../../common/services/Contact.service';
import { ContactAddComponent } from './contact_add.component';
import { ContactEditComponent } from './contact_edit.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ConfirmDialogModule,
    GrowlModule,
    TooltipModule,
    BrowserModule,
    HelperModule,
    CardModule,
    PaginationModule,
    ToastrModule.forRoot(),
    // AgmCoreModule.forRoot({
    //     apiKey: 'AIzaSyB8xaQN4DvbHynW34FOJkdJNRYrrWd39aI'
    // }),
  ],

  declarations: [ContactsComponent, ContactAddComponent, ContactEditComponent],
  exports: [ContactsComponent, ContactAddComponent, ContactEditComponent],

  providers: [UploadEvsService, ContactService],
})
export class ContactModule {}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/contact/contact.module.ts